import { useState } from "react";
import { Check, Minus, ShieldCheck, ChevronDown } from "lucide-react";

// Jediná pravda o rolích a modulech — používá ji karta Tým na zakázce i záložka
// Oprávnění v Nastavení, ať se dvě tabulky nikdy nerozejdou. Hodnoty odpovídají
// skutečnému kódu (require_roles na backendu + navFor, guardy rout a podmínky
// v UI). Když se oprávnění změní, uprav TADY a projeví se na obou místech.
// Tři délky popisku: `short` na mobil (sloupec 52 px), `mid` na desktop
// (sloupec 80 px) a `full` do tooltipu. Plné názvy se do hlavičky nevejdou —
// přetekly by přes sousední sloupec (Asistent/ka přes Dělníka).
const COLS = [
  { full: "Majitel", mid: "Majitel", short: "Maj." },
  { full: "Stavbyvedoucí", mid: "Stavbyved.", short: "Stav." },
  { full: "Asistent/ka", mid: "Asistent", short: "Asis." },
  { full: "Projektant", mid: "Projektant", short: "Proj." },
  { full: "Dělník", mid: "Dělník", short: "Děl." },
  { full: "Subdodavatel", mid: "Subdod.", short: "Sub." },
  { full: "Účetní", mid: "Účetní", short: "Úč." },
];

// true = má právo, false = nemá, string = upřesnění. Pořadí sloupců viz COLS.
// Projektant (DESIGNER) podle backendu: diary.py, tasks.py (TASK_LEADS), planning.py,
// pasport.py (EDIT_ROLES bez něj), NO_ATTENDANCE_ROLES a navFor v Layout.js.
const GROUPS = [
  ["Moduly v menu", [
    ["Přehled", [true, true, true, true, true, true, false]],
    ["Tabule (kdo je v práci)", [true, true, false, false, false, false, false]],
    ["Zakázky", [true, true, true, "jen své", "jen své", false, false]],
    ["Docházka", [true, true, true, false, "jen svá", "jen svá", false]],
    ["Deník", [true, true, true, "jen své", false, false, false]],
    ["Sklad", [true, true, true, false, false, false, false]],
    ["Gantt (plánování)", [true, true, true, "jen čte", false, false, false]],
    ["Úkoly", [true, true, true, "své zakázky", "jen své", "jen své", false]],
    ["Ekonomika", [true, true, true, false, false, false, true]],
    ["Tým", [true, true, true, false, false, false, false]],
    ["Investoři", [true, true, true, false, false, false, false]],
    ["Moje faktury", [false, false, false, false, false, true, false]],
    ["Nastavení", [true, true, true, true, true, true, true]],
  ]],
  ["Zakázka — karty v detailu", [
    ["Informace a Harmonogram", [true, true, true, "jen své", "jen své", false, false]],
    ["Deník, Docházka, Fotky", [true, true, true, "jen své", false, false, false]],
    ["Rozpočet a Ekonomika", [true, true, true, false, false, false, false]],
    ["Pasport", [true, true, true, "jen čte", "jen čte", false, false]],
    ["Historie a Tým", [true, true, true, "jen své", "jen své", false, false]],
  ]],
  ["Zakázky — akce", [
    ["Zakládá a upravuje zakázku", [true, true, true, false, false, false, false]],
    ["Mění stav zakázky", [true, true, true, false, false, false, false]],
    ["Fáze, milníky, harmonogram", [true, true, true, false, false, false, false]],
    ["Maže zakázku do koše a obnovuje", [true, false, true, false, false, false, false]],
    ["Zakládá a upravuje investory", [true, true, true, false, false, false, false]],
  ]],
  ["Docházka a výkazy", [
    ["Zapisuje svou docházku", [true, true, true, false, true, true, false]],
    ["Vidí, kdo je právě v práci", [true, true, true, false, false, false, false]],
    ["Zapisuje docházku za ostatní", [true, true, true, false, false, false, false]],
    ["Opravuje a maže docházku", [true, true, true, false, false, false, false]],
    ["Schvaluje a vrací výkazy", [true, "jen své stavby", true, false, false, false, false]],
    ["Nastavení docházky firmy", [true, false, true, false, false, false, false]],
  ]],
  ["Stavební deník", [
    ["Čte deník", [true, "jen své stavby", true, "jen své stavby", false, false, false]],
    ["Píše zápis do deníku", [true, true, "jen čte", "jen své stavby", false, false, false]],
    ["Nahrává fotky do deníku", [true, true, true, "jen své stavby", false, false, false]],
    ["Schvaluje a maže fotky", [true, true, false, "jen své stavby", false, false, false]],
  ]],
  ["Úkoly", [
    ["Vidí úkoly", ["všechny", "všechny", "všechny", "své zakázky", "jen své", "jen své", false]],
    ["Zadává úkoly komukoli", [true, true, true, "na svých zakázkách", false, false, false]],
    ["Zadá úkol sobě nebo vedení", [true, true, true, true, true, true, false]],
    ["Plní úkoly a nahrává fotky", [true, true, true, true, true, true, false]],
    ["Schvaluje a vrací hotové úkoly", [true, true, true, "na svých zakázkách", false, false, false]],
  ]],
  ["Sklad a materiál", [
    ["Hlásí spotřebu při odhlášení", [true, true, true, false, true, false, false]],
    ["Příjem, výdej, převod, inventura", [true, true, true, false, false, false, false]],
    ["Ruční příjem a odpis", [true, true, true, false, false, false, false]],
    ["Potvrzuje hlášení spotřeby", [true, true, true, false, false, false, false]],
    ["Maže hlášení spotřeby", [true, true, false, false, false, false, false]],
  ]],
  ["Pasport a vzorník", [
    ["Vidí pasport zakázky", [true, true, true, "jen čte", "jen čte", false, false]],
    ["Upravuje položky a objednává", [true, true, true, false, false, false, false]],
    ["Spravuje vzorník a šablony", [true, false, true, false, false, false, false]],
  ]],
  ["Peníze", [
    ["Vidí rozpočet a náklady zakázky", [true, true, true, false, false, false, false]],
    ["Vidí firemní čísla na Přehledu", [true, false, true, false, false, false, false]],
    ["Doklady, účtenky, platby, režie", [true, true, true, false, false, false, true]],
    ["Vydané faktury", [true, false, true, false, false, false, true]],
    ["Schvaluje faktury subdodavatelů", [true, true, true, false, false, false, false]],
    ["Vystavuje vlastní faktury firmě", [false, false, false, false, false, true, false]],
  ]],
  ["Tým a lidé", [
    ["Vidí tým a detail člověka", [true, true, true, false, false, false, false]],
    ["Zve nové členy", [true, false, true, false, false, false, false]],
    ["Mění hodinové sazby", [true, false, true, false, false, false, false]],
    ["Deaktivuje a obnovuje člena", [true, "jen dělníky a subdodavatele", true, false, false, false, false]],
    ["Maže člena natrvalo", [true, false, false, false, false, false, false]],
    ["Dokumenty člena týmu", [true, true, true, false, false, false, false]],
  ]],
  ["Nastavení a firma", [
    ["Profil, heslo, vzhled", [true, true, true, true, true, true, true]],
    ["Údaje firmy a kategorie", [true, false, true, false, false, false, false]],
    ["Propojení (AI asistent, MCP)", [true, true, true, false, false, false, false]],
    ["Tabulka oprávnění", [true, true, true, false, false, false, false]],
    ["Bezpečnost a historie změn", [true, false, false, false, false, false, false]],
  ]],
];

function Cell({ v }) {
  if (v === true) return <Check size={15} className="text-success mx-auto" aria-label="ano" />;
  if (v === false) return <Minus size={15} className="text-muted-foreground/40 mx-auto" aria-label="ne" />;
  return <span className="block text-[10px] font-semibold text-muted-foreground leading-tight">{v}</span>;
}

export function PermissionsMatrix({ compact = false }) {
  // Na zakázce je tabulka jen doplněk — skupiny jsou sbalené, ať karta neroste
  // do nekonečna. V Nastavení je to hlavní obsah stránky, tam jsou rozbalené.
  const [open, setOpen] = useState(() =>
    Object.fromEntries(GROUPS.map(([g], i) => [g, compact ? false : i < 2])));
  const toggle = (g) => setOpen((s) => ({ ...s, [g]: !s[g] }));
  // Sedm sloupců se na úzkou kartu nevejde — mřížka scrolluje uvnitř karty,
  // stránka se neroztahuje (na mobilu i na zakázce).
  // Na mobilu úzké sloupce (52 px) + krátké zkratky, na desktopu širší (80 px)
  // + čitelnější popisky. Kompaktní varianta na zakázce zůstává úzká.
  // Na mobilu pevných 52 px a vodorovný posun. Na desktopu se sloupce dělí
  // o dostupné místo (fr) — mřížka se tak nikdy neořízne, ať je karta široká
  // jakkoli. Kompaktní varianta na zakázce zůstává úzká.
  const grid = compact
    ? "grid grid-cols-[minmax(160px,1fr)_repeat(7,52px)] gap-x-1"
    : "grid grid-cols-[minmax(160px,1fr)_repeat(7,52px)] lg:grid-cols-[minmax(180px,1.6fr)_repeat(7,minmax(64px,1fr))] gap-x-1";
  return (
    <div className={compact ? "bg-card border border-border rounded-[14px] p-4" : "bg-card border border-border rounded-[20px] p-4 md:p-5"}
      data-testid="permissions-matrix">
      <div className="flex items-center gap-2 mb-1">
        <ShieldCheck size={16} className="text-brand shrink-0" />
        <h3 className={compact ? "text-[15px] font-bold" : "text-[17px] font-bold"}>Oprávnění — kdo co vidí</h3>
      </div>
      <p className="text-[12px] text-muted-foreground mb-3">
        Celý přehled aplikace po modulech a rolích. Dělník a subdodavatel se k penězům firmy
        nebudou dostávat; projektant vidí jen své zakázky bez peněz a docházku neeviduje; účetní vidí jen ekonomiku, žádné stavby ani lidi. Tabulku vidí jen vedení.
      </p>
      <div className="min-w-0 overflow-x-auto">
        <div className={compact ? "min-w-[550px]" : "min-w-[550px] lg:min-w-0 lg:max-w-[1000px]"}>
          <div className={`${grid} items-end pb-1.5 border-b border-border sticky top-0 bg-card z-10`}>
            <span className="text-[10px] font-bold uppercase tracking-wide text-muted-foreground">Modul / právo</span>
            {COLS.map((c) => (
              <span key={c.full} title={c.full}
                className="text-[10px] font-bold uppercase tracking-wide text-muted-foreground text-center leading-tight min-w-0 truncate whitespace-nowrap">
                <span className="lg:hidden">{c.short}</span>
                <span className="hidden lg:inline xl:hidden">{compact ? c.short : c.mid}</span>
                <span className="hidden xl:inline">{compact ? c.short : c.full}</span>
              </span>
            ))}
          </div>
          {GROUPS.map(([group, rows]) => (
            <div key={group}>
              <button type="button" onClick={() => toggle(group)} data-testid={`perm-group-${group}`}
                className="w-full flex items-center gap-1.5 text-left text-[11px] font-extrabold uppercase tracking-[.08em] text-brand pt-3 pb-1 hover:opacity-80">
                <ChevronDown size={13} className={`transition-transform ${open[group] ? "" : "-rotate-90"}`} />
                {group}
                <span className="font-semibold text-muted-foreground normal-case tracking-normal">({rows.length})</span>
              </button>
              {open[group] && rows.map(([label, vals]) => (
                <div key={label} className={`${grid} items-center py-1.5 border-b border-border/50 last:border-0`}>
                  <span className="text-[13px] text-muted-foreground pr-2">{label}</span>
                  {vals.map((v, i) => <span key={i} className="text-center"><Cell v={v} /></span>)}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 pt-3 border-t border-border text-[11px] text-muted-foreground">
        <span className="flex items-center gap-1"><Check size={13} className="text-success" /> má právo</span>
        <span className="flex items-center gap-1"><Minus size={13} className="text-muted-foreground/40" /> nemá právo</span>
        <span>text = platí jen v uvedeném rozsahu</span>
      </div>
      {/* Zkratky v hlavičce rozepsané — na mobilu je v ní jen „Maj.", „Stav."… */}
      <p className="mt-1.5 text-[11px] text-muted-foreground">
        Maj. = majitel · Stav. = stavbyvedoucí · Asis. = asistent/ka · Proj. = projektant · Děl. = dělník
        · Sub. = subdodavatel · Úč. = účetní
      </p>
    </div>
  );
}
